import VideoPlayer from './platform/video_player'

export default VideoPlayer
